import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import CatalogueSidebarSubcategory from './CatalogueSidebarSubcategory';

const CatalogueSidebarCategory = ({
  cat,
  isActiveCategory,
  currentSubcategoryId,
  isExpanded,
  onToggle,
}) => {
  const subcategories = cat.subcategories || [];

  return (
    <div>
      <div className="flex items-center">
        <Link
          to={`/catalogue/${cat.slug}`}
          className={`flex-1 px-3 py-2 rounded-lg text-sm transition-colors ${
            isActiveCategory
              ? 'bg-orange-100 text-orange-700 font-medium'
              : cat.highlight
                ? 'text-orange-600 hover:bg-orange-50 font-medium'
                : 'text-gray-700 hover:bg-gray-100'
          }`}
          data-testid={`sidebar-${cat.slug}`}
        >
          {cat.name}
        </Link>
        <button
          onClick={() => onToggle(cat.id)}
          className="p-1 hover:bg-gray-100 rounded"
          aria-label={`Toggle ${cat.name}`}
        >
          <ChevronDown
            className={`w-4 h-4 text-gray-400 transition-transform ${isExpanded ? 'rotate-180' : ''}`}
          />
        </button>
      </div>

      {isExpanded && (
        <div className="ml-4 mt-1 space-y-1 border-l-2 border-gray-100 pl-3">
          {subcategories.map((sub) => (
            <CatalogueSidebarSubcategory
              key={sub.id}
              catSlug={cat.slug}
              sub={sub}
              isActive={currentSubcategoryId === sub.id}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default CatalogueSidebarCategory;
